module.exports = __webpack_public_path__ + "media/application/images/svgs/icons/plus-5fb1fccb719426232983642ceb2e7d2e.svg";